# Action types
export SET_FORM_DATA = 'SET_FORM_DATA'
